export default defineComponent({
  name: 'TwoTextItem',
  props: {
    text: String,
    value: String
  }
});